export function initToggleTheme(container = document) {
  const toggles = [];

  // 1. Cherche tous les toggles dans le container
  container.querySelectorAll('.toggle-theme').forEach(el => toggles.push(el));

  // 2. Cherche le bouton global ID (compatibilité)
  const globalToggle = document.getElementById('toggle-theme');
  if (globalToggle && !toggles.includes(globalToggle)) toggles.push(globalToggle);

  // Thème mémorisé appliqué sur toutes les pages, même sans bascule
  try {
    const saved = localStorage.getItem('theme');
    if (saved === 'dark' || saved === 'light') {
      document.documentElement.classList.toggle('theme-dark', saved === 'dark');
      document.documentElement.classList.toggle('theme-light', saved === 'light');
    }
  } catch (e) {}

  if (!toggles.length) return;

  // Retourne le mode actuel : 'light', 'dark', ou 'auto'
  function getCurrentMode() {
    return localStorage.getItem('theme') || 'auto';
  }

  // Applique le mode sur le DOM via les classes html
  function applyMode(mode) {
    document.documentElement.classList.toggle('theme-dark', mode === 'dark');
    document.documentElement.classList.toggle('theme-light', mode === 'light');
    // auto : les deux classes sont retirées, le CSS gère via color-scheme: light dark
  }

  // Détecte si un toggle bouton est en mode 3 états (présence de .icon-auto)
  function is3StateButton(toggle) {
    return !!toggle.querySelector('.icon-auto');
  }

  // Détecte si un toggle checkbox est en mode 3 états (présence de .switch-thumb__content--auto)
  function is3StateSwitch(toggle) {
    return !!toggle.nextElementSibling?.querySelector('.switch-thumb__content--auto');
  }

  // Met à jour l'état visuel de toutes les checkboxes
  function syncCheckboxes() {
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const mode = getCurrentMode();
    const resolvedIsDark = mode === 'dark' || (mode === 'auto' && prefersDark);

    toggles.forEach(t => {
      if (t.type !== 'checkbox') return;
      if (is3StateSwitch(t)) {
        // Switch 3 états : indeterminate = auto, checked = dark
        t.indeterminate = (mode === 'auto');
        t.checked = (mode === 'dark');
      } else {
        // Switch 2 états : reflète l'état résolu
        t.indeterminate = false;
        t.checked = resolvedIsDark;
      }
    });
  }

  // Cycle bouton 3 états : auto → light → dark → auto
  function nextMode(current) {
    if (current === 'auto') return 'light';
    if (current === 'light') return 'dark';
    return 'auto';
  }

  // Enregistre et applique un nouveau mode
  function setMode(mode) {
    if (mode === 'auto') {
      localStorage.removeItem('theme');
    } else {
      localStorage.setItem('theme', mode);
    }
    applyMode(mode);
    syncCheckboxes();
  }

  // Init : applique le mode stocké si présent, sinon laisse le CSS gérer (auto)
  const storedTheme = localStorage.getItem('theme');
  if (storedTheme) {
    applyMode(storedTheme);
  }
  syncCheckboxes();

  // Listeners
  toggles.forEach(toggle => {
    if (toggle.dataset.listenerAttached) return;
    toggle.dataset.listenerAttached = true;

    if (toggle.type === 'checkbox') {
      if (is3StateSwitch(toggle)) {
        // Switch 3 états : on laisse le change natif se produire puis on écrase
        // immédiatement l'état — pas de flash car JS est synchrone avant le repaint
        toggle.addEventListener('change', () => {
          setMode(nextMode(getCurrentMode()));
        });
      } else {
        // Switch 2 états : binaire light / dark
        toggle.addEventListener('change', () => {
          setMode(toggle.checked ? 'dark' : 'light');
        });
      }
    } else if (is3StateButton(toggle)) {
      // Bouton 3 états : cycle auto → light → dark → auto
      toggle.addEventListener('click', () => {
        setMode(nextMode(getCurrentMode()));
      });
    } else {
      // Bouton 2 états (rétrocompatibilité) : bascule light ↔ dark
      toggle.addEventListener('click', () => {
        const isDark = document.documentElement.classList.contains('theme-dark');
        setMode(isDark ? 'light' : 'dark');
      });
    }
  });

  // Suit les changements OS en temps réel — uniquement en mode auto
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    if (getCurrentMode() === 'auto') {
      syncCheckboxes();
    }
  });
}
